import { formatCountry, formatNationalityOption } from '@blockpulse3/helpers';

import { IUserContext } from '../../providers';
import { IUpdateAddressForm } from './UpdateAddressForm';
import { IUpdateProfileForm } from './UpdateProfileForm';

/**
 * fmtProfile.
 * Format MeQuery from context into default form values.
 *
 * @param {IUserContext['user']} data
 * @returns {IUpdateProfileForm}
 */
export function fmtProfile(data: IUserContext['user']): IUpdateProfileForm {
  const nationality = formatNationalityOption(data?.individualIdentity?.nationality || '');

  return {
    /* ** Always set empty string for default <input type="file"/> values ** */
    profilePicture: '',
    birthdate: data?.individualIdentity?.birthdate || '',
    birthplace: data?.individualIdentity?.birthplace || '',
    firstName: data?.individualIdentity?.firstName || '',
    lastName: data?.individualIdentity?.lastName || '',
    nationality,
    gender: data?.individualIdentity?.gender || '',
  };
}

/**
 * fmtAddress.
 * Format address from individualIdentity into default form values.
 *
 * @param {IUserContext['user']} data
 * @returns {IUpdateAddressForm}
 */
export function fmtAddress(data: IUserContext['user']): IUpdateAddressForm {
  return {
    line: data?.individualIdentity?.address?.line || '',
    city: data?.individualIdentity?.address?.city || '',
    postalCode: data?.individualIdentity?.address?.postalCode || '',
    country: {
      label: formatCountry(data?.individualIdentity?.address?.country || ''),
      value: data?.individualIdentity?.address?.country || '',
    },
  };
}
